export default __webpack_public_path__ + "static/media/reactflix.f4070143.png";